import React from "react";

import { Box, CircularProgress, Container, Typography } from "@mui/material";
import { ReturnButton } from "components/ReturnButton";
import toast from "react-hot-toast";
import { useParams } from "react-router-dom";
import { getEvolutions } from "requests/Evolution";
import { useAuth } from "shared/providers/auth";

import { Image } from "react-grid-gallery";

import * as Styled from "./styles";
import { GalleryDocuments } from "components/Gallery";

export interface CustomImage extends Image {
  original: string;
}

const EvolutionScreen: React.FC<{
  idPacientParam?: number;
  onClick?: () => void;
}> = ({ idPacientParam, onClick }) => {
  const { user } = useAuth();
  const { idPacient } = useParams();

  const [loading, setLoading] = React.useState<boolean>(false);
  const [images, setImages] = React.useState<CustomImage[]>([]);

  const evolutionAll = React.useCallback(async () => {
    setLoading(true);

    try {
      const { status, data } = await getEvolutions({
        userId: user.data.id,
        idPac: Number(
          idPacientParam && idPacientParam > 0 ? idPacientParam : idPacient
        ),
      });

      if ([200, 201].includes(status)) {
        const mappedImages: CustomImage[] = data.data.map((item: any) => ({
          src: item.image_url,
          original: item.image_url,
          width: 250,
          height: 212,
          caption: `Criado em ${item.criado_em}`,
        }));

        setImages(mappedImages);

        setLoading(false);
      } else {
        toast.error(data.message);
        setLoading(false);
      }
    } catch (e: any) {
      setLoading(false);
    }
    setLoading(false);
  }, [idPacient, idPacientParam, user]);

  React.useEffect(() => {
    evolutionAll();
  }, [evolutionAll]);

  return (
    <Container maxWidth="xl">
      <ReturnButton title="Evolução" onClick={onClick} />
      {loading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "80vh",
          }}
        >
          <CircularProgress size={54} />
        </Box>
      ) : (
        <>
          <Styled.ContainerPictures>
            {images.length > 0 ? (
              <GalleryDocuments images={images} />
            ) : (
              <Typography>Não existe registros.</Typography>
            )}
          </Styled.ContainerPictures>
        </>
      )}
    </Container>
  );
};

export { EvolutionScreen };
